import React from 'react';

const ArrowdownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.00002 1.16699V12.8337M7.00002 12.8337L12.8334 7.00033M7.00002 12.8337L1.16669 7.00033" stroke="#F04438" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default ArrowdownIcon;
